import { ADD_CONTRACT, FETCH_CONTRACTS, DELETE_CONTRACT, SHOW_CONTRACT, UPDATE_CONTRACT, DELETE_PAYMENT, ADD_PAYMENT, GET_TOTAL_CONTRACTS, GET_CONTRACTS_INFO, UPDATE_PRINT_CONTRACT, RESEND_EMAIL, GET_RECENT_MEDICAL_RECORDS, GET_LAST_WEEK_CONTRACTS_INFO, GET_LAST_MONTH_CONTRACTS_INFO, GET_CONTRACTS_VIA_CUSTOMER_STATE,
  GET_PDF_7005_CONTRACTS_DATA, FETCH_CONTRACT_SHIPPERS, UPDATE_CONTRACT_SHIPPERS   } from '../actions';

const initialState = {
  selectedToDelete: null,
  contract: '',
  contracts: [],
  loading: false,
  error: null,
  showContract: '',
  deletedPayment: null,
  newPayment: '',
  conCount: 0,
  contractInfo: null,
  conCountError: null,
  contractsError: null,
  contractError: null,
  selectedToDeleteError: null,
  showContractError: null,
  updatedContractError: null,
  deletedPaymentError: null,
  newPaymentError: null,
  contractInfoError: null,
  printContract: '',
  printContractError: null,

};

// Reducer
function ContractsReducer(state = initialState, action) {
  let selectedToDelete,
    contract,
    contracts,
    showContract,
    updatedContract,
    deletedPayment,
    newPayment,
    conCount,
    contractInfo,
    printContract,
    email,
    searchedMedicalRecords,
    contractLastWeekInfo,
    contractLastMonthInfo,    
    contractsViaCustomerState,
    monthlyContracts,
    signSignature,
    contractShippers,
    contractUpdatedShippers;

  switch (action.type) {
    case `${FETCH_CONTRACTS}_PENDING`:
    case `${ADD_CONTRACT}_PENDING`:
    case `${DELETE_CONTRACT}_PENDING`:
    case `${SHOW_CONTRACT}_PENDING`:
    case `${UPDATE_CONTRACT}_PENDING`:
    case `${DELETE_PAYMENT}_PENDING`:
    case `${ADD_PAYMENT}_PENDING`:
    case `${GET_TOTAL_CONTRACTS}_PENDING`:
    case `${GET_CONTRACTS_INFO}_PENDING`:
    case `${UPDATE_PRINT_CONTRACT}_PENDING`:
    case `${GET_RECENT_MEDICAL_RECORDS}_PENDING`:
    case `${GET_PDF_7005_CONTRACTS_DATA}_PENDING`:
      return { ...state, loading: true };

    case `${GET_TOTAL_CONTRACTS}_FULFILLED`:
      conCount = action.payload.data;
      return { ...state, loading: false, conCount };
    case `${FETCH_CONTRACTS}_FULFILLED`:
      contracts = action.payload.data;
      return { ...state, loading: false, contracts };

    case `${ADD_CONTRACT}_FULFILLED`:
      contract = action.payload.data;
      return { ...state, loading: false, contract };

    case `${DELETE_CONTRACT}_FULFILLED`:
      selectedToDelete = action.payload.data;
      return { ...state, loading: false, selectedToDelete };

    case `${SHOW_CONTRACT}_FULFILLED`:
      showContract = action.payload.data;
      return { ...state, loading: false, showContract };

    case `${UPDATE_CONTRACT}_FULFILLED`:
      updatedContract = action.payload.data;
      return { ...state, loading: false, updatedContract };

    case `${DELETE_PAYMENT}_FULFILLED`:
      deletedPayment = action.payload.data;
      return { ...state, loading: false, deletedPayment };

    case `${ADD_PAYMENT}_FULFILLED`:
      newPayment = action.payload.data;
      return { ...state, loading: false, newPayment };

    case `${GET_CONTRACTS_INFO}_FULFILLED`:
      contractInfo = action.payload.data;
      return { ...state, loading: false, contractInfo };

    case `${UPDATE_PRINT_CONTRACT}_FULFILLED`:
      printContract = action.payload.data;
      return { ...state, loading: false, printContract };

    case `${GET_RECENT_MEDICAL_RECORDS}_FULFILLED`:
      searchedMedicalRecords = action.payload.data;
      return { ...state, loading: false, searchedMedicalRecords };    
    
    case `${GET_LAST_WEEK_CONTRACTS_INFO}_FULFILLED`:
        contractLastWeekInfo = action.payload.data;
        return { ...state, loading: false, contractLastWeekInfo }; 

    case `${GET_LAST_MONTH_CONTRACTS_INFO}_FULFILLED`:
        contractLastMonthInfo = action.payload.data;
        return { ...state, loading: false, contractLastMonthInfo };  

    case `${ GET_CONTRACTS_VIA_CUSTOMER_STATE}_FULFILLED`:
        contractsViaCustomerState = action.payload.data;
        return { ...state, loading: false, contractsViaCustomerState }; 

    case `${GET_PDF_7005_CONTRACTS_DATA}_FULFILLED`:
        monthlyContracts = action.payload.data;
        return { ...state, loading: false, monthlyContracts };       
 
    case `${FETCH_CONTRACT_SHIPPERS}_FULFILLED`:
       contractShippers = action.payload.data;
       return { ...state, loading: false, contractShippers };    
          
    case `${UPDATE_CONTRACT_SHIPPERS}_FULFILLED`:
       contractUpdatedShippers = action.payload.data;
       return { ...state, loading: false, contractUpdatedShippers };      

    case `${FETCH_CONTRACTS}_REJECTED`:
      return { ...state, loading: false, contractsError: `${action.payload.message}`, state: initialState };
    case `${ADD_CONTRACT}_REJECTED`:
      return { ...state, loading: false, contractError: `${action.payload.message}`, state: initialState };
    case `${DELETE_CONTRACT}_REJECTED`:
      return { ...state, loading: false, selectedToDeleteError: `${action.payload.message}`, state: initialState };
    case `${SHOW_CONTRACT}_REJECTED`:
      return { ...state, loading: false, showContractError: `${action.payload.message}`, state: initialState };
    case `${UPDATE_CONTRACT}_REJECTED`:
      return { ...state, loading: false, updatedContractError: `${action.payload.message}`, state: initialState };
    case `${DELETE_PAYMENT}_REJECTED`:
      return { ...state, loading: false, deletedPaymentError: `${action.payload.message}`, state: initialState };
    case `${ADD_PAYMENT}_REJECTED`:
      return { ...state, loading: false, newPaymentError: `${action.payload.message}`, state: initialState };
    case `${GET_TOTAL_CONTRACTS}_REJECTED`:
      return { ...state, loading: false, conCountError: `${action.payload.message}`, state: initialState };
    case `${GET_CONTRACTS_INFO}_REJECTED`:
      return { ...state, loading: false, contractInfoError: `${action.payload.message}`, state: initialState };
    case `${UPDATE_PRINT_CONTRACT}_REJECTED`:
      return { ...state, loading: false, printContractError: `${action.payload.message}`, state: initialState };
    case `${GET_RECENT_MEDICAL_RECORDS}_REJECTED`:
        return { ...state, loading: false, searchedMedicalRecordsError: `${action.payload.message}`, state: initialState };
    case `${GET_LAST_WEEK_CONTRACTS_INFO}_REJECTED`:
        return { ...state, loading: false, contractLastWeekInfoError: `${action.payload.message}`, state: initialState };
    case `${GET_LAST_MONTH_CONTRACTS_INFO}_REJECTED`:
        return { ...state, loading: false, contractLastMonthInfoError: `${action.payload.message}`, state: initialState };
    case `${GET_CONTRACTS_VIA_CUSTOMER_STATE}_REJECTED`:
        return { ...state, loading: false,  contractsViaCustomerStateError: `${action.payload.message}`, state: initialState };
    case `${GET_PDF_7005_CONTRACTS_DATA}_REJECTED`:
        return { ...state, loading: false,  monthlyContractsError: `${action.payload.message}`, state: initialState }; 
    case `${FETCH_CONTRACT_SHIPPERS}_REJECTED`:
      return { ...state, loading: false,  contractShippersError: `${action.payload.message}`, state: initialState };
    case `${UPDATE_CONTRACT_SHIPPERS}_REJECTED`: 
      return { ...state, loading: false,  contractUpdatedShippersError: action.payload.response.data, state: initialState };
    case `${RESEND_EMAIL}_FULFILLED`:
      email = action.payload.data;
      return { ...state, loading: false, email };

    default:
      return state;
  }
}

export default ContractsReducer;

